import { Carousel } from 'antd';
import { useAppDispatch, useAppSelector, useAppTranslation } from 'app/hooks';
import WarningIcon from 'assets/icons/WarningIcon';
import eventBg3 from 'assets/images/daily_win_banner.gif';
import { showInfoModal } from 'components/Modals/CommonModals';
import { DONT_SHOW_EVENT_AT_DATE_LOCALSTORAGE } from 'consts/app';
import {
  onChangeAuthPage,
  selectEvent,
  selectShowEventNoti,
  setShowEventNoti,
} from 'features/home/homeSlice';
import useUserDetail from 'hooks/useUserDetail';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { isShowEventNoti } from 'utils/commonUtils';
import { formatDateNoTime } from 'utils/dateUtils';
import { formatAmountV2 } from 'utils/formatAmount';
import { setLocalStorage } from 'utils/sessionStorage';

interface EventNotiProps {}

const EventNoti: React.FunctionComponent<EventNotiProps> = () => {
  const showEventNoti = useAppSelector(selectShowEventNoti);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const event = useAppSelector(selectEvent);
  const { isUserLoggedIn, currentUser } = useUserDetail();
  const t = useAppTranslation();
  const [showAgainTomorrow, setShowAgainTomorrow] = useState<boolean>(false);
  const [showMoreInfo, setShowMoreInfo] = useState<boolean>(false);
  const [showTerm, setShowTerm] = useState<boolean>(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const currentBanner = event?.banners[currentIndex];
  const isVideo = currentBanner && /\.(mp4|mov|avi)$/i.test(currentBanner);
  const handleShowAgainTomorrow = () => {
    setLocalStorage(DONT_SHOW_EVENT_AT_DATE_LOCALSTORAGE, new Date().toISOString());
    closeNotiEvent();
  };

  const closeNotiEvent = () => {
    dispatch(setShowEventNoti(false));
    setShowMoreInfo(false);
  };

  const handleMoreInfo = () => {
    setShowMoreInfo((prev) => !prev);
  };

  const hendleShowTerm = () => {
    setShowTerm((prev) => !prev);
  };

  const handleClickEvent = () => {
    closeNotiEvent();
    if (!isUserLoggedIn) {
      return dispatch(onChangeAuthPage(1));
    }
    if (currentUser?.kyc?.status === 'APPROVED') {
      showInfoModal({
        title: t('notification'),
        content: <p>{t('event-noti.kyc-done')}</p>,
        width: 360,
        icon: <WarningIcon />,
      });
      return;
    } else {
      return navigate('/kyc');
    }
  };

  useEffect(() => {
    setShowAgainTomorrow(!isShowEventNoti());
  }, [isShowEventNoti, showEventNoti]);

  const showInfo = () => {
    return (
      <div className="event-noti-content-info bottom-to-top">
        <p className="event-noti-content-info-title">{event?.name}</p>
        <p className="event-noti-content-info-description">{event?.description}</p>
        <p className="event-noti-content-info-description">
          <strong className="font-bold">Reward: </strong>
          {formatAmountV2(event?.campaignDetail?.rewardInfo.amount, 2)} $TBET
        </p>
        <p className="event-noti-content-info-description">
          <strong className="font-bold">Time: </strong>
          {formatDateNoTime(event?.startDate || '')} - {formatDateNoTime(event?.endDate || '')}
        </p>
        <p className="event-noti-content-info-description">
          <strong className="font-bold">Remaining User : </strong>
          {formatAmountV2(event?.campaignDetail?.rewardInfo.remainingUser, 0)} /{' '}
          {formatAmountV2(event?.campaignDetail?.rewardInfo.totalUser, 0)}
        </p>
        {currentUser?.kyc?.status !== 'APPROVED' &&
          event?.campaignDetail &&
          event?.campaignDetail.rewardInfo.remainingUser > 0 && (
            <button
              className="button-common-primary event-noti-content-info-btn "
              onClick={handleClickEvent}
            >
              KYC Now
            </button>
          )}
      </div>
    );
  };

  return (
    <>
      <div
        className={`overlay center-content-col primary-text-color ${
          showEventNoti ? 'show' : 'hidden'
        }`}
      >
        <div className="event-noti event-noti-img-bg">
          <div className="event-noti-img">
            <Carousel
              autoplay={!isVideo}
              autoplaySpeed={5000}
              infinite
              effect="fade"
              dotPosition="top"
              pauseOnHover={false}
              arrows
              beforeChange={(from, to) => setCurrentIndex(to)}
              prevArrow={<div>{'<'}</div>}
              nextArrow={<div>{'>'}</div>}
            >
              {event &&
                event.banners.map((banner, index) => {
                  const isVideo = /\.(mp4|mov|avi)$/i.test(banner);

                  return (
                    <div key={index} className="event-noti-container">
                      {isVideo ? (
                        <video
                          autoPlay
                          controls
                          playsInline
                          className="video-carousel"
                          loop
                          muted={!showEventNoti}
                        >
                          <source src={banner} />
                        </video>
                      ) : (
                        <img src={banner} alt="Event banner" className="img-carousel" />
                      )}
                      <button className="event-noti-btn" onClick={handleMoreInfo}>
                        More info
                      </button>
                      {showMoreInfo && showInfo()}
                    </div>
                  );
                })}
              <div className="event-noti-container ">
                <img src={eventBg3} alt={'Casino event'} className="img-carousel pb-50" />
                <div className="event-noti-content-info bottom-to-top">
                  <p className="event-noti-content-info-title">Terms & Conditions</p>

                  <p className="event-noti-content-info-description">
                    Daily Wins will run from 24th March 2025 to 30th March 2026 with total of
                    $3,500,000 to be awarded across 12 levels.
                  </p>
                </div>
                <button className="event-noti-btn" onClick={hendleShowTerm}>
                  Read more
                </button>
              </div>
            </Carousel>
          </div>

          <div className="event-noti-header">
            <button className="event-noti-close-btn" onClick={closeNotiEvent}>
              x
            </button>
          </div>

          {!showAgainTomorrow && (
            <div
              className="checkbox-wrapper-1 event-noti-checkbox"
              onClick={handleShowAgainTomorrow}
            >
              <span>Skip today</span>
            </div>
          )}
        </div>
      </div>
      <TermsConditionsPopup isOpen={showTerm} onClose={hendleShowTerm} />
    </>
  );
};

export default EventNoti;

type TermsConditionsPopupProps = {
  isOpen: boolean;
  onClose: (accepted: boolean) => void;
};

const TermsConditionsPopup: React.FunctionComponent<TermsConditionsPopupProps> = ({
  isOpen,
  onClose,
}) => {
  const handleDecline = () => {
    onClose(false);
  };

  if (!isOpen) return null;

  return (
    <div className="terms-popup-overlay">
      <div className="terms-popup-container">
        <div className="terms-popup-header">
          <h2>Terms and Conditions</h2>

          <button className="terms-popup-close-btn " onClick={handleDecline}>
            ×
          </button>
        </div>

        <div className="terms-popup-content">
          <div className="terms-popup-scroll">
            <p>
              <strong>
                Daily Wins will run from 24th March 2025 to 30th March 2026 with total of $3,500,000
                to be awarded across 12 levels.
              </strong>
            </p>
            <p>
              <strong>1.</strong> 140,000 winners will win cash prizes worth $317,100 from 24 March
              2025, 14:00 to 28 April 2025, 02:00 (GMT+8) in the first level.
            </p>

            <p>
              <strong>2.</strong> Tournaments will run 4 times per day with 1,000 winners and prizes
              worth $2,265 per tournament. There will be a total of 140 tournaments during the
              promotion period.
              <br />
              Tournament schedule:
              <br />
              14:00 – 16:59 (GMT+8)
              <br />
              17:00 – 19:59 (GMT+8)
              <br />
              20:00 – 22:59 (GMT+8)
              <br />
              23:00 – 02:00 (GMT+8)
            </p>
            <p>
              <strong>3.</strong> Winners are based on Largest win from a single spin (adjusted for
              bet value).
            </p>

            <p>
              <strong>4.</strong> Scores = (Largest single win during tournament)/(winning bet
              during tournament) * 100
            </p>
            <p>
              Sample computation:
              <br />
              Player 1: bet $1 -&gt; win $50 (score = $50 / $1 * 100 = 5,000)
              <br />
              Player 2: bet $1 -&gt; win $5 (score = $5 / $1 * 100 = 500)
            </p>
            <p>
              <strong>5.</strong> No minimum bet is required for this promotion.
            </p>

            <p>
              <strong>6.</strong> Players will win prizes in the form of a multiplier of the winning
              player’s bet amount as set out in the prize table.
            </p>
            <p>
              <strong>7.</strong> If the winning spin exceeds $0.25, the prize will be paid out
              based on a bet of $0.25 X multiplier received.
            </p>
            <p>
              <strong>8.</strong> Qualified Games: All Pragmatic Play games except Money Roll, Irish
              Charms, Diamonds are Forever 3 lines, Mahjong Wins 2, Casino Heist Megaways™, Happy
              Fortune, Mahjong X, Gemstone, Supermania, Bali Dragon, Saiyan Mania, Xmas Spark,
              Wukong Rush, Old Gold Miner Megaways™, Wildman Super Bonanza, Sweet Bonanza Dice™,
              Joker Jewels Dice™, The Dog House Dice Show™, Gates of Olympus Dice, Sugar Rush
              Dice, Wolf Gold Dice, Money Stack Dice, Roma, Archer Gold, Gates of Olympus Pachi,
              Mahjong Wins – Gong Xi Fa Cai, Gates of Olympus 1000 Dice, Sweet Bonanza 1000 Dice,
              Big Bass Dice, Table Games, Video Poker, and Scratch Cards.
            </p>
            <p>
              <strong>9.</strong> If there are two or more players with identical score in
              tournament leaderboard, the player who scores it first will get the higher position on
              the leaderboard.
            </p>
            <p>
              <strong>10.</strong> The tournament leaderboard is built in the qualifying games and
              updates in real time.
            </p>
            <p>
              <strong>11.</strong> Pragmatic Play reserves the right to thoroughly review players
              activities to identify any potential abuse to ensure fair play within our Network
              Promotion. If any abuse is found, Pragmatic Play reserves the right to forfeit any
              amounts paid to winning players.
            </p>
            <p>
              <strong>12.</strong> Pragmatic Play reserves the right to amend, suspend or cancel the
              promotion at any time and without prior notice.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
